import { PlatformSettingsNotificationEventDto } from './platform-settings-notification-event.dto';

export class PlatformSettingsNotificationsDto {
  rentalAgreements?: {
    email?: {
      userCreated?: PlatformSettingsNotificationEventDto;
      userUpdated?: PlatformSettingsNotificationEventDto;
      userDeleted?: PlatformSettingsNotificationEventDto;
      userStarted?: PlatformSettingsNotificationEventDto;
      userCompleted?: PlatformSettingsNotificationEventDto;
      userCancelled?: PlatformSettingsNotificationEventDto;
    };
  };
  rentalReservations?: {
    email?: {
      userCreated?: PlatformSettingsNotificationEventDto;
      userUpdated?: PlatformSettingsNotificationEventDto;
      userAccepted?: PlatformSettingsNotificationEventDto;
      userRejected?: PlatformSettingsNotificationEventDto;
      userDeleted?: PlatformSettingsNotificationEventDto;
      userCancelled?: PlatformSettingsNotificationEventDto;
      customerAccepted?: PlatformSettingsNotificationEventDto;
      customerRejected?: PlatformSettingsNotificationEventDto;
    };
  };
}
